
export class SerialNumberStatus {
    guid: string;
    sn_id: string;
    status: string;
    remarks: string;
  }